
/**
 * Purpose of these "Actions" is to mimic a more redux-style of event management, which
 * should make transitioning to redux a little easier when the time comes.
 */

const NS = 'NetworkConnectionActionsService';

export const STATUS_CHANGE = 'status-change';

class NetworkConnectionActionsService {

  private $rootScope: any;

  setup($rootScope: any) {
    this.$rootScope = $rootScope;
  }

  handleStatusChange(cb: (...args: any) => void, actionName: string = STATUS_CHANGE): void {
    return this.$rootScope.$on(actionName, (...args: any) => cb(...args));
  }

  statusChange() {
    this.$rootScope.$broadcast(STATUS_CHANGE);
  }
}

// singleton
const instance = new NetworkConnectionActionsService();
export default instance as NetworkConnectionActionsService;
